// SignupPage.js
import React, { useState } from 'react';
import SignupForm from './SignupFrom';
import IndustrySignupForm from './IndustrySignupForm';
import { FaUser } from "react-icons/fa";
import { BsBuildingsFill } from "react-icons/bs";
import corporateBackgroud from '../../assets/corporate.jpg';
import userGroupBackground from '../../assets/usergroup.jpg';

const back1 = "bg-[rgba(255,255,255,0.61)] rounded-lg shadow-[0_4px_30px_rgba(209,67,67,0.1)] backdrop-blur-[20px]"
const back2 = "bg-[rgba(255,255,255,0.61)] rounded-lg shadow-[0_4px_30px_rgba(209,67,67,0.1)] backdrop-blur-[20px]"

function TogleUser({ Type, handleToggle }) {
  return (
    <div className="flex w-[100%] rounded-3xl">

      <div className={`flex w-full ${Type === "industry" ? 'bg-gradient-to-tr from-[var(--color-fill)] to-[var(--color-contrast)] shadow-[0_4px_30px_rgba(209,67,67,0.1)]' : 'bg-gray-200'} rounded-tl-3xl`}>
      <div
        onClick={() => handleToggle("participant")}
        className={`${Type === "participant" ? "bg-white text-2xl text-gray-700 rounded-tr-3xl rounded-tl-3xl p-4 " : "bg-gray-200 text-lg rounded-br-3xl rounded-tl-3xl p-4 text-gray-400   "} w-full flex justify-center font-semibold font-custom `}>
        Participant 
      </div>
      </div>

      <div className={`flex w-full ${Type === "participant" ? 'bg-white' : 'bg-gray-200'} rounded-tr-3xl`}>      
        <div
        onClick={() => handleToggle("industry")}
        className={`${Type === "industry" ? " bg-gradient-to-br from-[var(--color-contrast)] to-[var(--color-fill)] text-2xl text-white  rounded-t-3xl p-4" : "bg-gray-200 text-lg rounded-tr-3xl rounded-bl-3xl p-4 text-gray-400 "} w-full flex justify-center font-semibold font-custom `}>
        Industry
      </div>
      </div>

    </div>
  );
}

const SignupPage = () => {
  const [type, setType] = useState("participant");
  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = (newType) => {
    if (newType === type) {
      return;
    }
    setType(newType);
    setIsToggled(!isToggled);
  };


  return (
    // <div className="flex min-h-screen bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
    //   {/* Sign-in Side */}
    //   <div className="hidden lg:flex w-1/2 bg-transparent justify-center items-center relative">
    //     {/* Blue tint overlay */}
    //     <div className="absolute inset-0 bg-blue-600 opacity-50"></div>
    //     {/* Black overlay for additional effect */}
    //     <div className="absolute inset-0 bg-black bg-opacity-30"></div>

    //     <div className="relative z-10 text-center text-white">
    //       <p className="text-xl mb-6">
    //         Already have an account? Sign in and explore more of our amazing features.
    //       </p>
    //       <button
    //         onClick={() => window.location.href = '/login'}
    //         className="bg-white text-blue-600 px-6 py-2 rounded-md font-semibold hover:bg-gray-200 shadow-md"
    //       >
    //         Sign In
    //       </button>
    //     </div>
    //   </div>

    //   {/* Signup Form Side */}
    //   <div className="w-full lg:w-1/2 flex justify-center items-center bg-gray-100 p-8 flex-col gap-2"
    //     style={{
    //       backgroundImage: `url(${isToggled ? corporateBackgroud : userGroupBackground})`,
    //       backgroundSize: 'cover',
    //       backgroundPosition: 'center'
    //     }}>
    //     <div className="absolute inset-50 bg-blue-300 opacity-50"></div>

        <div className="flex flex-col justify-center items-center bg-white rounded-3xl drop-shadow-2xl shadow-[0_4px_30px_rgba(209,67,67,0.1)] ">
          <TogleUser Type={type} handleToggle={handleToggle} />
          {isToggled ? <IndustrySignupForm /> : <SignupForm />}
        </div>
      // </div>
    // </div>
  );
};

export default SignupPage;
